import { HlmTooltip } from './lib/hlm-tooltip';

export * from './lib/hlm-tooltip';

export const HlmTooltipImports = [HlmTooltip] as const;
